import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { DashboardUnits } from '@dataTypes/dashboard.types'
import { SliderComponent } from '@syncfusion/ej2-react-inputs'

import './DashboardStyle.css'

type SliderData = {
  unit: DashboardUnits
  goal: number
  actual: number
}
type DashboardSliderProps = {
  title: string
  label: string
  data: SliderData
  toggleSlider: (e: any) => void
}
function DashboardSlider({
  title,
  label,
  data,
  toggleSlider,
}: DashboardSliderProps): React.ReactElement {
  return (
    <Row className="text-center">
      <Col className="text-black">{label}</Col>
      <Col md={12}>
        <div className="dashboard-control-pane" key={title}>
          <div className="dashboard-control-section dashboard-slider p-0 m-0 ">
            <SliderComponent
              id={title}
              value={data.actual}
              min={0}
              max={100}
              width={100}
              limits={{ enabled: true, minEnd: data.actual }}
              change={(e: any) => toggleSlider(e)}
            />
          </div>
        </div>
      </Col>
      <Col md={12} className="">
        <span className="text-blue">{`Goal ${data.goal}%`}</span>
        <span className="me-1 ms-1">|</span>
        <span className="text-black">{`Actual ${data.actual}%`}</span>
      </Col>
    </Row>
  )
}

export default DashboardSlider
